import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-design',
  templateUrl: './report-design.component.html',
  styleUrls: ['./report-design.component.css']
})
export class ReportDesignComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
